// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { updateuser, userService } from "../../services/AuthenticationService";


// const MyAddress = () => {
//   const userId = useSelector((state) => state.auth.userId); 
//   const [formData, setFormData] = useState({
//     address1: "",
//     address2: "",
//     address3: "",
//     deliveryAddress: "",
//   });

//   useEffect(() => {
//         if (userId) {
//           userService(userId)
//             .then((response) => {
//               setFormData(response);
//             })
//             .catch((error) => console.error("Error fetching profile:", error));
//         }
//       }, [userId]);
//   const [newData, setnewData] = useState({
//     address1: "",
//     address2: "",
//     address3: "",
//     deliveryAddress: "",
//   });
//   useEffect(() => {
//         if (userId) {
//           userService(userId)
//             .then((response) => {
//               setnewData(response);
//             })
//             .catch((error) => console.error("Error fetching profile:", error));
//         }
//       }, [userId]);
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]:  value,
//     });
//   };

//   const handleSubmit = async (e) => {
//          e.preventDefault();
//          //console.log("Form Submitted", formData);
//          try {
//            const response = await updateuser(formData);
//            //console.log("Profile updated:", response);
//            alert("Profile updated successfully!");
//          } catch (error) {
//            console.error("Error updating profile:", error);
//            alert("Failed to update profile.");
//          }
//        };
//   return (
//   <div className="account-page">
//     <section className="checkout-section pb-5">
//       <div className="account-form">
//             <form onSubmit={handleSubmit} className="billing-form ">
//             <div className="col-md-7 heading-section ">
//                 <span className="subheading">Addresses</span>
//                 </div>
//               <div className="row align-items-end mt-5">
//                 <div className="col-md-12">
//                   <label>Permanent Address</label>
//                   <input type="text" name="firstName" value={formData.address1} onChange={handleChange} className="form-control" />
//                 </div>
//                 <div className="col-md-12">
//                   <label>Delivery Address 1</label>
//                   <input type="text" name="lastName" value={formData.address2} onChange={handleChange} className="form-control" />
//                 </div>
//                 <div className="col-md-12">
//                   <label>Delivery Address 2</label>
//                   <input type="text" name="lastName" value={formData.address3} onChange={handleChange} className="form-control" />
//                 </div>
//               </div>
//               <button type="submit"
//                    className="btn btn-primary btn-outline-primary rounded-0 mt-2" 
//                   > 
//                    Save changes
//                    </button>
//             </form>
            
//       </div>
//     </section>
//     </div>
//   );
// };

// export default MyAddress;

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { updatecustomer, updateuser, userService } from "../../services/AuthenticationService";

const MyAddress = () => {
  const userId = useSelector((state) => state.auth.userId);

  const [formData, setFormData] = useState(null);
  const [originalData, setOriginalData] = useState(null);

  useEffect(() => {
    if (userId) {
      userService(userId)
        .then((response) => {
          setFormData(response);
          setOriginalData(response); // Store original data
        })
        .catch((error) =>
          console.error("Error fetching profile:", error)
        );
    }
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const hasChanges = () => {
    if (!formData || !originalData) return false;
    return (
      formData.address1 !== originalData.address1 ||
      formData.address2 !== originalData.address2 ||
      formData.address3 !== originalData.address3
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await updatecustomer(formData);
      alert("Address updated successfully!");
      setOriginalData(formData); // Update originalData after saving
    } catch (error) {
      console.error("Error updating address:", error);
      alert("Failed to update address.");
    }
  };

  if (!formData) return <div>Loading...</div>;

  return (
    <div className="account-page">
      <section className="checkout-section pb-5">
        <div className="account-form">
          <form onSubmit={handleSubmit} className="billing-form">
            <div className="col-md-7 heading-section">
              <span className="subheading">Addresses</span>
            </div>
            <div className="row align-items-end mt-5">
              <div className="col-md-12">
                <label>Permanent Address</label>
                <input
                  type="text"
                  name="address1"
                  value={formData.address1 || ""}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="col-md-12">
                <label>Delivery Address 1</label>
                <input
                  type="text"
                  name="address2"
                  value={formData.address2 || ""}
                 // onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="col-md-12">
                <label>Delivery Address 2</label>
                <input
                  type="text"
                 name="address3"
                  value={formData.address3 || ""}
                 //onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>

            {hasChanges() && (
              <button
                type="submit"
                className="btn btn-primary btn-outline-primary rounded-0 mt-2"
              >
                Save changes
              </button>
            )}
          </form>
        </div>
      </section>
    </div>
  );
};

export default MyAddress;
